import { EditFormProps } from "./EditFormProps";
import { UseEditFormResponse } from "./useEditForm";
import { FormProvider } from "react-hook-form";
import { Field } from "./FieldsFactory";
import { ErrorMessage } from "./StyleComponents";
import { noop, translate } from "@kaltura/mediaspace-shared-utils";
import { ConfirmationModal } from "@kaltura/mediaspace-shared-ui";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config/useConfig";
/**
 * The UI of the entry edit form.
 */
export const EditFormContents = (props: Pick<EditFormProps, "formData" | "fieldsStructure"> & UseEditFormResponse) => {
    const { formData, fieldsStructure, useFormHookMethods, modalData, handleLeave } = props;
    const config = useConfig();
    const { formState } = useFormHookMethods;

    return (
        <FormProvider {...useFormHookMethods}>
            {fieldsStructure.map((field) => {
                // Derive consistent field name including belongsTo prefix
                const fieldName = field.belongsTo ? `${field.belongsTo}.${field.id}` : field.id;
                const isFieldRequired = field.required;
                const hasError = Boolean(
                    isFieldRequired && useFormHookMethods.getFieldState(fieldName, formState).error
                );
                const errorId = `${fieldName}-error`;

                return (
                    <div key={fieldName}>
                        {Field(
                            field,
                            {
                                data: formData,
                                ariaDescribedBy: hasError ? errorId : undefined,
                                dateFormat: config.application.shortDateFormat,
                            }
                        )}
                        {hasError && (
                            <ErrorMessage id={errorId}>
                                {translate("%1 is a required field", [field.label || field.id])}
                            </ErrorMessage>
                        )}
                    </div>
                );
            })}

            <ConfirmationModal
                open={!!modalData}
                noButtonLabel={translate("Leave")}
                noCallback={handleLeave}
                yesButtonLabel={modalData?.yesButtonLabel}
                yesCallback={modalData?.yesCallback || noop}
                title={modalData?.title}
                text={modalData?.text}
            />
        </FormProvider>
    );
};
